import React from "react"
import PropTypes from "prop-types"

// Components
import Axis from "../Axis/Axis"
import Line from "../Line/Line"

// Utils
import { colors, gaugeScale } from "../utils"

const LineChartViz = props => {
  // Props
  const {
    svgWidth,
    svgHeight,
    margin,
    w,
    h,
    labelXScale,
    lineXScale,
    lineYScale,
    lineDataLabels
  } = props

  // Helper Functions

  // Axis, Line, Text, Rect Props
  const leftAxisProps = {
    orientation: "left",
    scale: lineYScale,
    translate: `translate(${margin.left}, ${margin.top})`,
    // ticks: 6,
    tickValues: [0, 20, 40, 60, 80, 100],
    classes: "line-bar-right font-weight-bold",
    tickSize: [-w],
    tickColorScale: gaugeScale
  }

  const bottomAxisProps = {
    orientation: "bottom",
    scale: labelXScale,
    translate: `translate(${margin.left}, ${h + margin.top})`,
    classes: "line-bar-bottom"
  }

  const lineProps = {
    data: lineDataLabels,
    xScale: lineXScale,
    yScale: lineYScale,
    xKey: "month",
    yKey: "score",
    colorArr: colors,
    translate: `translate(${labelXScale.bandwidth() / 2}, 0)`,
    svgHeight
  }

  return (
    <svg width={svgWidth} height={svgHeight} className="line-bar">
      <Axis {...leftAxisProps} />
      <Axis {...bottomAxisProps} />
      <g transform={`translate(${margin.left}, ${margin.top})`}>
        <Line {...lineProps} />
      </g>
    </svg>
  )
}

export default LineChartViz

LineChartViz.propTypes = {
  svgWidth: PropTypes.number.isRequired,
  svgHeight: PropTypes.number.isRequired,
  margin: PropTypes.shape({
    left: PropTypes.number,
    right: PropTypes.number,
    bottom: PropTypes.number,
    top: PropTypes.number
  }).isRequired,
  w: PropTypes.number.isRequired,
  h: PropTypes.number.isRequired,
  labelXScale: PropTypes.func.isRequired,
  lineXScale: PropTypes.func.isRequired,
  lineYScale: PropTypes.func.isRequired,
  lineDataLabels: PropTypes.arrayOf(
    PropTypes.shape({
      month: PropTypes.object,
      score: PropTypes.number
    })
  ).isRequired
}
